import type { ModalPayload } from '../../types/redux';

export const OPEN_MODAL = 'OPEN_MODAL' as const;
export const CLOSE_MODAL = 'CLOSE_MODAL' as const;
export const SET_DATA = 'SET_DATA' as const;
export const SET_POSITION = 'SET_POSITION' as const;
export const SET_SELECTED_INDEX = 'SET_SELECTED_INDEX' as const;

export const openModal = (modalType: string, data?: Record<string, unknown>) => ({
    type: OPEN_MODAL,
    payload: { modalType, data } as ModalPayload
});

export const setSelectedIndex = (index: number) => ({
    type: SET_SELECTED_INDEX,
    payload: index
});

export const closeModal = () => ({
    type: CLOSE_MODAL
});

export const setPoiData = (data: Record<string, unknown>) => ({
    type: SET_DATA,
    payload: data
});

export const setModalPosition = (position: Record<string, unknown>) => ({
    type: SET_POSITION,
    payload: position
});

export type ModalAction =
    | ReturnType<typeof openModal>
    | ReturnType<typeof setSelectedIndex>
    | ReturnType<typeof closeModal>
    | ReturnType<typeof setPoiData>
    | ReturnType<typeof setModalPosition>;
